import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { AuthService } from '../../../../admin/auth.service';
import { EmpresaService } from '../../../../../services/empresa.service';

@Component({
  selector: 'recuperar-senha-root',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.scss', '../login-empresa.component.scss']
})
export class RecuperarSenhaComponent {
    carregando = false;
    recuperarSenhaForm: FormGroup;
    submited = false;
    paginaLogado = '/indicacao'
      
    constructor(
        private _router: Router, 
        private fb: FormBuilder, 
        private messageService: MessageService, 
        private _empresaService: EmpresaService,
        private authService: AuthService,
    ){}

    ngOnInit(){
        if(this.authService.isLoggedInEmpresa()){
            this._router.navigate([this.paginaLogado]);
        }
        this.submited = false;
        this.createForm();
    }

    createForm(){
        this.recuperarSenhaForm = this.fb.group({
            emailRecuperar: ['', [Validators.email, Validators.required]],
        });
    }

    login(){
        this._router.navigate(['login-empresa']);
    }

    get f() {
        return this.recuperarSenhaForm.controls;
    }

    abrirModal(){
        document.getElementById("btnModal").click();
    }

    recuperarSenha(){
        this.submited = true;
        this.recuperarSenhaForm.markAsTouched();
        if(this.recuperarSenhaForm.invalid){
            this.messageService.add({ severity: 'error', summary: 'Atenção', detail: `Verifique todos os campos e tente novamente!` });
        }else{
            this.carregando = true;
            this._empresaService.recuperarSenha(this.f.emailRecuperar.value).subscribe((v) =>{
                //fazer requisição de recuperação de senha
                if(v){
                    //se der certo
                    this.abrirModal();
                }else{
                    this.messageService.add({ severity: 'error', summary: 'Erro', detail: `Empresa não encontrada e/ou e-mail não enviado.`});
                }
                this.carregando = false;
                
            },(e)=>{
                //se der outro erro qualquer
                console.log(e);
                this.messageService.add({ severity: 'error', summary: 'Erro inesperado', detail: `Ocorreu um erro inesperado. Tente novamente ou mais tarde.` });
                this.carregando = false;
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/_public-layout/pages/login/recuperar-senha/recuperar-senha.component.ts